import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'billing',
    lazy: async () => ({ Component: (await import('./BillingPage')).BillingPage }),
  },
];
